// extracted by mini-css-extract-plugin
export var md = "_4u-4";
export var semantic = "_4u-5";
export var sm = "_4u-3";
export var text = "_4u-6";
export var toggleInput = "_4u-0";
export var toggleSwitch = "_4u-1";
export var xs = "_4u-2";